import React from "react";
import { Icon } from "semantic-ui-react";
import ReactTooltip from "react-tooltip";
import "./FormField.css";

// Customisation Parameters
// size: mini, tiny, small, mid, large, big, huge, massive
// color: red, orange, yellow, olive, green, teal, blue, violet, purple, pink, brown, grey, black
// icon: refer to semantic icon set: https://react.semantic-ui.com/elements/icon/
// place: (placement relative to icon) top, right, bottom, left
// type: dark, success, warning, error, info, light

const HoverIcon = ({
  size,
  icon,
  text,
  place,
  // color = "teal",
  color,
  type,
  backgroundColor = "rgb(47, 224, 222)",
  // style = "color: rgb(47, 224, 222) !important",
  className,
  ...iconProps
}) => {
  return (
    <>
      <Icon name={icon} data-tip={text} size={size} color={color} className={className} style={{ color: "#3bb4d8" }} {...iconProps} />
      <ReactTooltip
        className="custom-tooltip"
        place={place}
        effect="solid"
        // If no custom type is supplied, it will default to readyteacher's teal
        // Don't pass both type and backgroundColor as props
        {...(type
          ? (type = { type })
          : (backgroundColor = { backgroundColor }))}
      />
    </>
  );
};

export default HoverIcon;
